import {
    SET_DATE_FILTER, SET_UTIL_DATE, SET_PROD_DATE, SET_HEALTH_DATE, SET_TIER_DATE, SET_TRENDS_DATE, SET_OPERATIONS_DATE, SET_IMC_DATE, SET_KOWA_DATE, SET_REPORTING_DATE, SET_REPORTMINING_DATE
} from './types';
 
const setLocationDate = (locationDates:any) => ({
    type: SET_DATE_FILTER,
    locationDates
})
const setUtilizationDate = (utilizationDates: any) => ({
    type: SET_UTIL_DATE,
    utilizationDates
})
const setHealthDate = (healthDates: any) => ({
    type: SET_HEALTH_DATE,
    healthDates
})
const setProductivityDate = (productivityDates: any) => ({
    type: SET_PROD_DATE,
    productivityDates
})
const setTierDate = (tierDates: any) => ({
    type: SET_TIER_DATE,
    tierDates
})
const setTrendsDate = (trendsDates: any) => ({
    type: SET_TRENDS_DATE,
    trendsDates
})
const setOperationsDate = (operationsDates: any) => ({
    type: SET_OPERATIONS_DATE,
    operationsDates
})
const setIMCDate = (imcDates: any) => ({
    type: SET_IMC_DATE,
    imcDates
})

const setKowaDate = (kowaDates: any) => ({
    type: SET_KOWA_DATE,
    kowaDates
})

const setReportingDate = (reportingDates: any) => ({
    type: SET_REPORTING_DATE,
    reportingDates
})

const setReportingMiningDate = (reportMiningDates: any) => ({
    type: SET_REPORTMINING_DATE,
    reportMiningDates
})

export {
    setLocationDate,
    setUtilizationDate,
    setHealthDate,
    setProductivityDate,
    setTierDate,
    setTrendsDate,
    setOperationsDate,
    setIMCDate,
    setKowaDate,
    setReportingDate,
    setReportingMiningDate
};
  